import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_KASIR_SET_LOADER,
        value: data
    }
};

export const getListReservasi = () => {
    return {
        type: types.MODULE_KASIR_LISTDATA_RESERVASI_GET,
    }
};

export const getDetailReservasi = (value) => {
    return {
        type: types.MODULE_KASIR_DETAIL_RESERVASI_GET,
        value
    }
};

export const handleStateFormPembayaran =  (property, value) => {
    return ({
        type: types.MODULE_KASIR_HANDLE_STATE_FORM_PEMBAYARAN,
        property,
        value
    })
}

export const submitPembayaranPasien = (history, value) => {
    return ({
        type: types.MODULE_KASIR_SUBMIT_FORM_INVOICE_RESERVASI,
        value,
        history
    })
}

